export default __webpack_public_path__ + "static/media/hour_glass.685ef2a6.gif";